/**
 * has retention policy
 *
 * Links to a retention policy.
 *
 * https://w3id.org/ldes#retentionPolicy
 */
export const retentionPolicy = 'https://w3id.org/ldes#retentionPolicy';
/**
 * amount
 *
 * Amount of versions to keep.
 *
 * https://w3id.org/ldes#amount
 */
export const amount = 'https://w3id.org/ldes#amount';
/**
 * point in time
 *
 * Only after this point in time, members are kept.
 *
 * https://w3id.org/ldes#pointInTime
 */
export const pointInTime = 'https://w3id.org/ldes#pointInTime';
/**
 * version key
 *
 * A list of SHACL property paths to compose a version key.
 *
 * https://w3id.org/ldes#versionKey
 */
export const versionKey = 'https://w3id.org/ldes#versionKey';
/**
 * versionOf Path
 *
 * SHACL property path to the non-versioned IRI of the entity.
 *
 * https://w3id.org/ldes#versionOfPath
 */
export const versionOfPath = 'https://w3id.org/ldes#versionOfPath';
/**
 * Timestamp Path
 *
 * SHACL property path to the xsd:dateTime literal in each member that defines the order of the event stream.
 *
 * https://w3id.org/ldes#timestampPath
 */
export const timestampPath = 'https://w3id.org/ldes#timestampPath';
/**
 * Version Materialization Of
 *
 * Links to the original LDES
 *
 * https://w3id.org/ldes#versionMaterializationOf
 */
export const versionMaterializationOf = 'https://w3id.org/ldes#versionMaterializationOf';
/**
 * Version Materialization Until
 *
 * Timestamp until versions were processed
 *
 * https://w3id.org/ldes#versionMaterializationUntil
 */
export const versionMaterializationUntil = 'https://w3id.org/ldes#versionMaterializationUntil';
/**
 * Event Stream
 *
 * An Event Stream is a tree:Collection containing immutable members.
 *
 * https://w3id.org/ldes#EventStream
 */
export const EventStream = 'https://w3id.org/ldes#EventStream';
/**
 * Event Source
 *
 * A data service that provides the source other views should synchronize with
 *
 * https://w3id.org/ldes#EventSource
 */
export const EventSource = 'https://w3id.org/ldes#EventSource';
/**
 * Retention Policy
 *
 * The abstract concept of a retention policy.
 *
 * https://w3id.org/ldes#RetentionPolicy
 */
export const RetentionPolicy = 'https://w3id.org/ldes#RetentionPolicy';
/**
 * The Linked Data Event Streams specification
 *
 * A hypermedia specification for maintaining a collection with immutable members.
 *
 * https://w3id.org/ldes#Vocabulary
 */
export const Vocabulary = 'https://w3id.org/ldes#Vocabulary';
export const _BASE = 'https://w3id.org/ldes#';
export const _PREFIX = 'ldes';
//# sourceMappingURL=ldes.js.map